import PreviewContainer from './PreviewContaner';


const DripNotificationPreview = ({drips, disable, edit, editMode, activeDrip, onCancel, deleteDrip}) => {

    const previewDrips = editMode ? activeDrip : drips;

    return <div className="col notification-preview-container d-sm-none d-md-block">
        <div className="box" style={{position: 'sticky', top: '0px'}} >
            <div className="d-flex mb-2">
                <h5 className="medium">{editMode ? 'Preview Drip Notification' :  'Active Drip Notifications'}</h5>
                {/* <a href="" className="ml-auto">Test Notifications</a> */}
            </div>
           
            {
                previewDrips.map((drip, index) => <div key={index} className="panel reminder-panel">
                <div className="panel-header">
                    { !editMode && <div className="d-flex mb-2">
                        <label className="toggle-control toggle-control-sm">
                            <input type="checkbox" checked={drip.is_active} onChange={(event) => disable(event, drip?.id, drip?.is_active)} />
                            <span className="control"></span>
                        </label>
                        <span>Reminder {index + 1}</span>
                    </div>  }                                              
                    <div className="d-flex flex-wrap align-items-center">
                        <small className="thin">Wait for {drip.scheduled_at}(s) </small>
                        { index < 1 && <small className="thin">after a new visitor subscribes, then send</small>}
                        { index >= 1 && <small className="thin">after the previous notification, then send</small>}
                    </div>
                </div>
                <div className="panel-body">                                                
                    <div style={{display: 'grid'}}>
                        <PreviewContainer {...drip} osSelected={'Windows'} browserSelected={'Chrome'} />
                        <div className="d-flex justify-content-around">
                        {
                                editMode ? <button className="btn btn-grey ml-3" onClick={()=> onCancel()}>Cancel Edit</button> 
                                : <button className="btn btn-grey ml-3" onClick={()=> edit(drip)}><i className="icon icon-edit"> </i>Edit Drip</button> 
                            }                    
                            <button className="btn btn-danger ml-3" onClick={()=> deleteDrip(drip.id)}><i className="icon icon-delete"> </i>Delete Drip</button> 
                        </div>        
                    </div>  
                </div>                                          
            </div>)
            }
            {
                drips.length <= 0 &&  <div className="text-center">
                    <span>You don't have any active notification <br /> Please add one</span>
                </div>
            }
            
        </div>
    </div>
}

export default DripNotificationPreview;